
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEqual } from 'lodash';
import hwaxios from '../api-service/HWAxios';
import { nocDashboardTypes } from '../reduxExports';
import rmsStore from '../rmsStore';


const url = process.env.REACT_APP_SERVER_BASE_URL;




export const fetchLatestChargerDetails: any = 
    (reqBody)=>
        async (dispatch): Promise<void> => {
           try{

                const loaderStartAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_LATEST_CHARGER_DETAILS_LOADER,
                    latestChargerDetailsLoader: true
                };
                dispatch(loaderStartAction);

                const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
                    ? reqBody.searchTerm.trim() : null;

                const filterHash = reqBody?.filters;

                const hashAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_LATEST_CHARGER_DETAILS_REQUEST_HASH,
                    latestChargerSearchHash: searchHash,
                    latestChargerFilterRequestHash: filterHash
                };
                dispatch(hashAction);

                const response = await hwaxios.post(url + '/noc-dashboard/charger-detail', reqBody);

                if (
                    searchHash === rmsStore.getState().nocDashboardReducer.latestChargerSearchHash && 
                    isEqual(filterHash,rmsStore.getState().nocDashboardReducer.latestChargerFilterRequestHash)
                ) {
                    const action = {
                        type: nocDashboardTypes.FETCH_LATEST_CHARGER_DETAILS,
                        latestChargerDetails: response?.data?.chargerDetails,
                        latestChargerAlarmDetails: response?.data?.alarmDetails
                    }

                    dispatch(action);
                }
            
                if (response?.status === 200) {
                    const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_LATEST_CHARGER_DETAILS_LOADER,
                        latestChargerDetailsLoader: false
                    };
                    dispatch(loaderEndAction);
                }
            } catch (error) {
                const loaderEndAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_LATEST_CHARGER_DETAILS_LOADER,
                    latestChargerDetailsLoader: false
                };
                dispatch(loaderEndAction);
                console.error(error);
                throw error;
            } 
        }



export const fetchNocDashboardChargerList: any = 
    (reqBody)=>
        async (dispatch): Promise<void> => {
           try{
                const loaderStartAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_LIST_LOADER,
                    nocDashboardChargerListLoader: true
                };
                dispatch(loaderStartAction);

                const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
                    ? reqBody.searchTerm.trim() : null;

                const filterHash = reqBody?.filters;

                const hashAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_LIST_REQUEST_HASH,
                    nocDashboardSearchHash: searchHash,
                    nocDashboardFilterRequestHash: filterHash
                };
                dispatch(hashAction);

                const response = await hwaxios.post(url + '/noc-dashboard', reqBody);
            

                if (
                    searchHash === rmsStore.getState().nocDashboardReducer.nocDashboardSearchHash && 
                    isEqual(filterHash,rmsStore.getState().nocDashboardReducer.nocDashboardFilterRequestHash)
                ) {
                    const action = {
                        type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_LIST,
                        nocDashboardChargerList: response?.data?.chargersList,
                        nocDashboardLatestAlarmCharger: response?.data?.latestAlarmCharger,
                        nocDashboardMapCenterCoordinates: response?.data?.averageCoordinates,
                        nocDashboardAlarmCounts:response?.data?.alarmCounts
                    }

                    dispatch(action);
                }
            
                if (response?.status === 200) {
                    const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_LIST_LOADER,
                        nocDashboardChargerListLoader: false
                    };
                    dispatch(loaderEndAction);
                }
            } catch (error) {
                const loaderEndAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_LIST_LOADER,
                    nocDashboardChargerListLoader: false
                };
                dispatch(loaderEndAction);
                console.error(error);
                throw error;
            } 
        }

export const fetchNocDashboardAlertCount: any = 
    (reqBody)=>
        async (dispatch): Promise<void> => {
           try{
                const loaderStartAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERT_COUNT_LOADER,
                    nocDashboardAlertsCountLoader: true
                };
                dispatch(loaderStartAction);

                const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
                    ? reqBody.searchTerm.trim() : null;

                const filterHash = reqBody?.filters;

                const hashAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERT_COUNT_REQUEST_HASH,
                    nocDashboardSearchHash: searchHash,
                    nocDashboardFilterRequestHash: filterHash
                };
                dispatch(hashAction);

                const response = await hwaxios.post(url + '/noc-dashboard/alerts-count', reqBody);
                if (
                    searchHash === rmsStore.getState().nocDashboardReducer.nocDashboardSearchHash && 
                    isEqual(filterHash,rmsStore.getState().nocDashboardReducer.nocDashboardFilterRequestHash)
                ) {
                    const action = {
                        type: nocDashboardTypes.FETCH_NOC_DASHBOARD_ALERT_COUNT,
                        nocDashboardAlertsCount: response?.data?.alertsCount,
                    }

                    dispatch(action);
                }
            
                if (response?.status === 200) {
                    const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERT_COUNT_LOADER,
                        nocDashboardAlertsCountLoader: false
                    };
                    dispatch(loaderEndAction);
                }
            } catch (error) {
                const loaderEndAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERT_COUNT_LOADER,
                    nocDashboardAlertsCountLoader: false
                };
                dispatch(loaderEndAction);
                console.error(error);
                throw error;
            } 
        }


export const fetchNocDashboardAlertsList: any = 
    (reqBody)=>
        async (dispatch): Promise<void> => {
           try{
                const loaderStartAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERTS_LIST_LOADER,
                    nocDashboardAlertsListLoader: true
                };
                dispatch(loaderStartAction);

                const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
                    ? reqBody.searchTerm.trim() : null;

                const filterHash = reqBody?.filters;

                const hashAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.FETCH_NOC_DASHBOARD_ALERTS_LIST_REQUEST_HASH,
                    nocDashboardAlertsListSearchHash: searchHash,
                    nocDashboardAlertsListFilterRequestHash: filterHash
                };
                dispatch(hashAction);

                const response = await hwaxios.post(url + '/noc-dashboard/alerts-list', reqBody);
          
                    const action = {
                        type: nocDashboardTypes.FETCH_NOC_DASHBOARD_ALERTS_LIST,
                        nocDashboardAlertsList: response?.data?.alertsList,
                    }
                    dispatch(action);
            
                if (response?.status === 200) {
                    const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERTS_LIST_LOADER,
                        nocDashboardAlertsListLoader: false
                    };
                    dispatch(loaderEndAction);
                }
            } catch (error) {
                const loaderEndAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_ALERTS_LIST_LOADER,
                    nocDashboardAlertsListLoader: false
                };
                dispatch(loaderEndAction);
                console.error(error);
                throw error;
            } 
        }



export const setFlagAlert: any = 
    (reqBody)=>
        async (): Promise<any> => {
           try{
              const res=  await hwaxios.post(url + '/noc-dashboard/flag-alert', reqBody);
            return{
                status:res?.status,
                data:res?.data
            };
            } catch (error) {
                console.error(error);
                throw error;
            } 
        }

export const fetchNocDashboardChargerAnalyticsData: any = 
    (reqBody)=>
        async (dispatch): Promise<void> => {
           try{
                const loaderStartAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ANALYTICS_LOADER,
                    nocDashboardChargerAnalyticsLoader: true
                };
                dispatch(loaderStartAction);

                const searchHash = reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
                    ? reqBody.searchTerm.trim() : null;

                const filterHash = reqBody?.filters;

                const hashAction: Partial<NOCDashboardAction> = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ANALYTICS_REQUEST_HASH,
                    nocDashboardChargerAnalyticsSearchHash: searchHash,
                    nocDashboardChargerAnalyticsFilterRequestHash: filterHash
                };
                dispatch(hashAction);

                const response = await hwaxios.post(url + '/noc-dashboard/charger-analytics', reqBody);
          
                if (
                    searchHash === rmsStore.getState().nocDashboardReducer.nocDashboardChargerAnalyticsSearchHash && 
                    isEqual(filterHash,rmsStore.getState().nocDashboardReducer.nocDashboardChargerAnalyticsFilterRequestHash)
                ){
                    const action = {
                        type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_ANALYTICS_DATA,
                        nocDashboardAlarmsPlotData: response?.data?.alarms,
                        nocDashboardChargingSessionsPlotData: response?.data?.sessions,
                        nocDashboardChargerUptimePlotData: response?.data?.uptime,
                        nocDashboardConsumedEnergyPlotData: response?.data?.consumedEnergy,
                        nocDashboardConnectorStatusData: response?.data?.connectorStatus
                    }
                    dispatch(action);
                }
            
                if (response?.status === 200) {
                    const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ANALYTICS_LOADER,
                        nocDashboardChargerAnalyticsLoader: false
                    };
                    dispatch(loaderEndAction);
                }
            } catch (error) {
                const loaderEndAction: Partial<NOCDashboardAction> = {
                        type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ANALYTICS_LOADER,
                        nocDashboardChargerAnalyticsLoader: false
                    };
                dispatch(loaderEndAction);
                console.error(error);
                throw error;
            } 
        }

export const fetchNocDashboardChargerSummary: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SUMMARY_LOADER,
				nocDashboardChargerSummaryLoader: true,
			};
			dispatch(loaderStartAction);
			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SUMMARY_REQUEST_HASH,
				nocDashboardChargerSummarySearchHash: searchHash,
				nocDashboardChargerSummaryFilterRequestHash: filterHash,
			};
			dispatch(hashAction);
			const response = await hwaxios.post(url + '/noc-dashboard/chargers-summary', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerSummarySearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerSummaryFilterRequestHash
				)
			) {
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_SUMMARY_DATA,
					nocDashboardChargerPerfomanceData: response?.data?.data,
				};
				dispatch(action);
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SUMMARY_LOADER,
					nocDashboardChargerSummaryLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SUMMARY_LOADER,
				nocDashboardChargerSummaryLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const fetchNocDashboardChargerPerfomanceRankings: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_RANKINGS_LOADER,
				nocDashboardChargerPerfomanceRankingsLoader: true,
			};
			dispatch(loaderStartAction);

			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFOMANCE_RANKINGS_REQUEST_HASH,
				nocDashboardChargerPerfomanceRankingSearchHash: searchHash,
				nocDashboardChargerPerfomanceRankingFilterHash: filterHash,
			};
			dispatch(hashAction);


			const response = await hwaxios.post(url + '/noc-dashboard/performance-rankings', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerPerfomanceRankingSearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerPerfomanceRankingFilterHash
				)
			) {
				if(reqBody.fetchType == 'utilization'){
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_UTILISATION_PERFOMANCE_RANKINGS_DATA,
					nocDashboardChargerUtilisationPerfomanceRankingsData: response?.data.data,
				};
			dispatch(action);}

				else if (reqBody.fetchType == 'efficiency'){
					const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_EFFICIENCY_PERFOMANCE_RANKINGS_DATA,
					nocDashboardChargerEfficiencyPerfomanceRankingsData: response?.data.data,
				};
				dispatch(action);
				}
				else{
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_UPTIME_PERFOMANCE_RANKINGS_DATA,
					nocDashboardChargerUptimePerfomanceRankingsData: response?.data.data,
				};
				dispatch(action);
				}				
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_RANKINGS_LOADER,
					nocDashboardChargerPerfomanceRankingsLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_RANKINGS_LOADER,
				nocDashboardChargerPerfomanceRankingsLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};


export const fetchNocDashboardChargerSessionPerfomance: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_LOADER,
				nocDashboardChargerPerformanceLoader: true,
                
			};
			dispatch(loaderStartAction);

			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFOMANCE_REQUEST_HASH,
				nocDashboardChargerPerfomanceSearchHash: searchHash,
				nocDashboardChargerPerfomanceFilterHash: filterHash,
			};
			dispatch(hashAction);


			const response = await hwaxios.post(url + '/noc-dashboard/charging-session-performance', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerPerfomanceSearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerPerfomanceFilterHash
				)
			) {
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_PERFOMANCE_DATA,
					nocDashboardChargerSessionPerfomanceData: response?.data.data,

				};
				dispatch(action);
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_LOADER,
					nocDashboardChargerPerformanceLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_PERFORMANCE_LOADER,
				nocDashboardChargerPerformanceLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const fetchNocDashboardChargerSessionVolume: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_LOADER,
				nocDashboardChargerSessionVolumeLoader: true,
                
			};
			dispatch(loaderStartAction);

			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_REQUEST_HASH,
				nocDashboardChargerSessionVolumeSearchHash: searchHash,
				nocDashboardChargerSessionVolumeFilterHash: filterHash,
			};
			dispatch(hashAction);


			const response = await hwaxios.post(url + '/noc-dashboard/charging-session-volume', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerSessionVolumeSearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerSessionVolumeFilterHash
				)
			) {
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_DATA,
					nocDashbaordChargerSessionVolumeData: response?.data.data,

				};
				dispatch(action);
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_LOADER,
					nocDashboardChargerSessionVolumeLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_SESSION_VOLUME_LOADER,
				nocDashboardChargerSessionVolumeLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const fetchNocDashboardChargerUptime: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_UPTIME_LOADER,
				nocDashboardChargerUptimeLoader: true,
                
			};
			dispatch(loaderStartAction);

			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_UPTIME_REQUEST_HASH,
				nocDashboardChargerUptimeSearchHash: searchHash,
				nocDashboardChargerUptimeFilterHash: filterHash,
			};
			dispatch(hashAction);


			const response = await hwaxios.post(url + '/noc-dashboard/charger-uptime', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerUptimeSearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerUptimeFilterHash
				)
			) {
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_UPTIME_DATA,
					nocDashboardChargerUptimeData: response?.data.data,

				};
				dispatch(action);
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_UPTIME_LOADER,
					nocDashboardChargerUptimeLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_UPTIME_LOADER,
				nocDashboardChargerUptimeLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};

export const fetchNocDashboardChargerAlarm: any =
	(reqBody) =>
	async (dispatch): Promise<void> => {
		try {
			const loaderStartAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ALARM_LOADER,
				nocDashboardChargerAlarmLoader: true,
                
			};
			dispatch(loaderStartAction);

			const searchHash =
				reqBody?.searchTerm && reqBody.searchTerm.trim() !== ''
					? reqBody.searchTerm.trim()
					: null;

			const filterHash = reqBody?.filters;
			const hashAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ALARM_REQUEST_HASH,
				nocDashboardChargerAlarmSearchHash: searchHash,
				nocDashboardChargerAlarmFilterHash: filterHash,
			};
			dispatch(hashAction);

			const response = await hwaxios.post(url + '/noc-dashboard/charger-alarm', reqBody);

			if (
				searchHash ===
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerAlarmSearchHash &&
				isEqual(
					filterHash,
					rmsStore.getState().nocDashboardReducer
						.nocDashboardChargerAlarmFilterHash
				)
			) {
				const action = {
					type: nocDashboardTypes.FETCH_NOC_DASHBOARD_CHARGER_ALARM_DATA,
					nocDashboardChargerAlarmData: response?.data.data,

				};
				dispatch(action);
			}

			if (response?.status === 200) {
				const loaderEndAction: Partial<NOCDashboardAction> = {
					type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ALARM_LOADER,
					nocDashboardChargerAlarmLoader: false,
				};
				dispatch(loaderEndAction);
			}
		} catch (error) {
			const loaderEndAction: Partial<NOCDashboardAction> = {
				type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_ALARM_LOADER,
				nocDashboardChargerAlarmLoader: false,
			};
			dispatch(loaderEndAction);
			console.error(error);
			throw error;
		}
	};



export const setChargerIdsForRedirection : any = 
    (data)=>
        async (dispatch): Promise<void> => {
            try{
                const action = {
                    type: nocDashboardTypes.SET_NOC_DASHBOARD_CHARGER_IDS_FOR_REDIRECTION,
                    nocDashboardChargerIdsForRedirection: data
                }
                dispatch(action)

            }catch(error){
                console.error(error)
                throw error;
            }
        }

export const setNocDashboardActiveTab: any = (data) => async (dispatch: (arg0: Partial<NOCDashboardAction>)=>void): Promise<void> => {
	try {
		const action: Partial<NOCDashboardAction> = {
			type: nocDashboardTypes.SET_NOC_DASHBOARD_ACTIVE_TAB,
			nocDashboardActiveTab: data
		}
		dispatch(action);
	} catch (error) {
		console.error(error);
		throw error;
	}
} 